/* ============================================================================
   Yuvakart — SMS OTP verify widget (BulkSMS via secure Worker proxy)
   SETUP: replace WORKER_URL below with your deployed Cloudflare Worker URL.

   Use anywhere:
     window.YK_OTP.open({ onVerified: function(phone, proof){ ... } });
     window.YK_OTP.isVerified()  → verified phone (string) or null
   Or add data-yk-otp to any button/link to open the popup on click.
   Fires document event 'yk:otp-verified' with {phone, proof} on success.
   ============================================================================ */
(function () {
  'use strict';
  if (window.YK_OTP) return;

  var WORKER_URL = 'https://plain-pine-1366.gayatrikartabu.workers.dev';

  var GOLD = '#C49A2A', GOLD2 = '#F0D67A', DARK = '#1A0800', CREAM = '#FBF3E4';
  var LS = 'yk_otp_verified';

  /* ------------------------------------------------------------- styles -- */
  var css =
    '.ykotp-ov{position:fixed;inset:0;background:rgba(20,10,2,.55);z-index:2147480000;' +
    'display:none;align-items:center;justify-content:center;padding:18px;' +
    '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}' +
    '.ykotp-ov.on{display:flex}' +
    '.ykotp{width:100%;max-width:340px;background:' + CREAM + ';border:1px solid ' + GOLD + ';' +
    'border-radius:16px;padding:22px 20px 18px;box-shadow:0 18px 50px rgba(20,10,2,.35);' +
    'font-family:inherit;position:relative;text-align:center}' +
    '.ykotp-x{position:absolute;top:8px;right:12px;border:0;background:none;font-size:22px;' +
    'color:#7a6a52;cursor:pointer;line-height:1}' +
    '.ykotp-ic{width:34px;height:34px;margin:0 auto 8px;display:flex;align-items:center;' +
    'justify-content:center;border:1.5px solid ' + GOLD + ';border-radius:50%}' +
    '.ykotp h3{margin:0 0 4px;font-size:16px;color:' + DARK + ';font-weight:700}' +
    '.ykotp p{margin:0 0 14px;font-size:12px;color:#6d5d45;line-height:1.45}' +
    '.ykotp input{width:100%;box-sizing:border-box;padding:11px 12px;font-size:15px;' +
    'border:1px solid rgba(196,154,42,.55);border-radius:10px;background:#fff;color:' + DARK + ';' +
    'outline:none;text-align:center;letter-spacing:1px}' +
    '.ykotp input:focus{border-color:' + GOLD + ';box-shadow:0 0 0 3px rgba(196,154,42,.15)}' +
    '.ykotp-btn{width:100%;margin-top:12px;padding:12px;border:0;border-radius:999px;' +
    'background:linear-gradient(180deg,#f7e7bd,#e8cd8c);color:#2a1f10;font-weight:700;' +
    'font-size:14px;cursor:pointer;box-shadow:0 6px 16px rgba(201,162,75,.28)}' +
    '.ykotp-btn[disabled]{opacity:.55;cursor:default}' +
    '.ykotp-err{margin:10px 0 0;font-size:12px;color:#b03a2e;min-height:15px}' +
    '.ykotp-sub{margin-top:10px;font-size:11px;color:#8a7a5f}' +
    '.ykotp-link{background:none;border:0;color:' + GOLD + ';font-size:12px;cursor:pointer;' +
    'margin-top:10px;text-decoration:underline}' +
    '.ykotp-ok{font-size:38px;line-height:1;margin:6px 0 2px}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* -------------------------------------------------------------- state -- */
  var ov, box, token = null, phone = '', cb = null, timer = null;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* GET with query params — a "simple request": no CORS preflight, works on
     networks where cross-origin POST is blocked (observed on this site). */
  function post(path, data) {
    var qs = Object.keys(data).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(data[k] == null ? '' : data[k]);
    }).join('&');
    return fetch(WORKER_URL + path + '?' + qs, { method: 'GET' })
      .then(function (r) { return r.json().then(function (j) { j.__s = r.status; return j; }); });
  }

  function shell(inner) {
    box.innerHTML =
      '<button class="ykotp-x" aria-label="Close">&times;</button>' +
      '<div class="ykotp-ic"><svg width="18" height="18" viewBox="0 0 20 20" fill="none">' +
      '<path d="M10 2C10 2 5 6.5 5 10.5C5 13.538 7.238 16 10 16C12.762 16 15 13.538 15 10.5C15 6.5 10 2 10 2Z" stroke="' + GOLD + '" stroke-width="1.2" stroke-linejoin="round"/>' +
      '<circle cx="10" cy="10.5" r="2" fill="' + GOLD + '" opacity=".5"/></svg></div>' + inner;
    box.querySelector('.ykotp-x').onclick = close;
  }

  /* ------------------------------------------------------------- screens -- */
  function stepPhone(prefill) {
    shell(
      '<h3>Verify your mobile</h3>' +
      '<p>We’ll send a one-time password by SMS to confirm your number.</p>' +
      '<input id="ykotp-ph" type="tel" inputmode="numeric" maxlength="10" placeholder="10-digit mobile" value="' + esc(prefill || '') + '">' +
      '<button class="ykotp-btn" id="ykotp-send">Send OTP</button>' +
      '<p class="ykotp-err" id="ykotp-e"></p>'
    );
    var inp = box.querySelector('#ykotp-ph'), btn = box.querySelector('#ykotp-send'),
        err = box.querySelector('#ykotp-e');
    inp.focus();
    btn.onclick = function () {
      var p = (inp.value || '').replace(/\D/g, '');
      if (!/^[6-9]\d{9}$/.test(p)) { err.textContent = 'Enter a valid 10-digit mobile'; return; }
      btn.disabled = true; btn.textContent = 'Sending…'; err.textContent = '';
      post('/send-otp', { phone: p }).then(function (j) {
        if (j.ok) { phone = p; token = j.token; stepOtp(); }
        else { btn.disabled = false; btn.textContent = 'Send OTP'; err.textContent = j.error || 'Could not send OTP'; }
      }).catch(function () { btn.disabled = false; btn.textContent = 'Send OTP'; err.textContent = 'Network error — try again'; });
    };
    inp.onkeydown = function (e) { if (e.key === 'Enter') btn.click(); };
  }

  function stepOtp() {
    shell(
      '<h3>Enter the OTP</h3>' +
      '<p>Sent to <b>+91 ' + esc(phone) + '</b> · valid for 5 minutes</p>' +
      '<input id="ykotp-code" type="tel" inputmode="numeric" maxlength="6" placeholder="6-digit OTP">' +
      '<button class="ykotp-btn" id="ykotp-go">Verify</button>' +
      '<p class="ykotp-err" id="ykotp-e"></p>' +
      '<button class="ykotp-link" id="ykotp-re" disabled>Resend in <span id="ykotp-t">30</span>s</button>'
    );
    var inp = box.querySelector('#ykotp-code'), btn = box.querySelector('#ykotp-go'),
        err = box.querySelector('#ykotp-e'), re = box.querySelector('#ykotp-re'),
        tEl = box.querySelector('#ykotp-t'), left = 30;
    inp.focus();
    clearInterval(timer);
    timer = setInterval(function () {
      left--; if (tEl) tEl.textContent = left;
      if (left <= 0) { clearInterval(timer); re.disabled = false; re.textContent = 'Resend OTP'; }
    }, 1000);
    re.onclick = function () { if (!re.disabled) { clearInterval(timer); stepPhone(phone); } };
    btn.onclick = function () {
      var c = (inp.value || '').replace(/\D/g, '');
      if (!/^\d{6}$/.test(c)) { err.textContent = 'Enter the 6-digit OTP'; return; }
      btn.disabled = true; btn.textContent = 'Verifying…'; err.textContent = '';
      post('/verify-otp', { phone: phone, otp: c, token: token }).then(function (j) {
        if (j.verified) {
          clearInterval(timer);
          try { localStorage.setItem(LS, JSON.stringify({ phone: phone, proof: j.proof, expiresAt: j.expiresAt, at: Date.now() })); } catch (e) {}
          stepDone();
          try { document.dispatchEvent(new CustomEvent('yk:otp-verified', { detail: { phone: phone, proof: j.proof } })); } catch (e) {}
          if (cb) { try { cb(phone, j.proof); } catch (e) {} }
        } else { btn.disabled = false; btn.textContent = 'Verify'; err.textContent = j.error || 'Incorrect OTP'; }
      }).catch(function () { btn.disabled = false; btn.textContent = 'Verify'; err.textContent = 'Network error — try again'; });
    };
    inp.onkeydown = function (e) { if (e.key === 'Enter') btn.click(); };
  }

  function stepDone() {
    shell(
      '<div class="ykotp-ok">✅</div>' +
      '<h3>Number verified</h3>' +
      '<p>+91 ' + esc(phone) + ' is confirmed. Thank you!</p>' +
      '<button class="ykotp-btn" id="ykotp-close2">Done</button>'
    );
    box.querySelector('#ykotp-close2').onclick = close;
    setTimeout(close, 2500);
  }

  /* --------------------------------------------------------------- api ---- */
  function ensure() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'ykotp-ov';
    ov.innerHTML = '<div class="ykotp"></div>';
    document.body.appendChild(ov);
    box = ov.querySelector('.ykotp');
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  }
  function open(opts) {
    if (WORKER_URL.indexOf('REPLACE-WITH') > -1) {
      console.warn('[YK_OTP] Set WORKER_URL in yk-otp.js first.'); return;
    }
    ensure();
    cb = opts && opts.onVerified || null;
    ov.classList.add('on');
    stepPhone(opts && opts.phone || '');
  }
  function close() { if (ov) ov.classList.remove('on'); clearInterval(timer); }
  function isVerified() {
    try {
      var v = JSON.parse(localStorage.getItem(LS) || 'null');
      if (v && v.phone && v.proof && Number(v.expiresAt) > Date.now()) return v.phone;
      if (v) localStorage.removeItem(LS);
      return null;
    } catch (e) { return null; }
  }

  window.YK_OTP = { open: open, close: close, isVerified: isVerified };

  /* click-to-open on any [data-yk-otp] element */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-yk-otp]');
    if (el) { e.preventDefault(); open(); }
  });

  /* Explicit test hook only; normal arrival prompt is controlled by yk-login-gate.js. */
  if (/[?&]ykotp=1/.test(location.search)) {
    var autoBoot = function () { setTimeout(open, 600); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoBoot);
    else autoBoot();
  }
})();
